import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import StripeForm from '../../../../../../commonComponents/forms/inputs/StripeForm';

function CreditCardAdd({ t, onAdd }) {
  const [showForm, setShowForm] = useState(false);
  const handleFinish = data => {
    onAdd(data);
    setShowForm(false);
  };

  return showForm ? (
    <StripeForm onFinish={handleFinish} onCancel={() => setShowForm(false)} />
  ) : (
    <div className="col-md-6 m--margin-bottom-30">
      <div className="m-card_add" onClick={() => setShowForm(true)}>
        <div className="m-card_add__body">
          <div className="m-card_add__img">
            <span>
              <i className="la la-credit-card" />
            </span>
          </div>
          <div className="m-card_add__text">
            <span>{t('add_card_payment')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

CreditCardAdd.propTypes = {
  t: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default translate(CreditCardAdd);
